export const NavBar = () => {
    return (

            <div className="navbar">
                <a className="navbar-banner navbar-item" href="/">
                    <div className="navbar-banner-image">
                        {/* div has image as BG*/}
                    </div>
                </a>
                <ul className="navbar-nav navbar-item">
                    <li className="border-animation border-animation-horizontal"><a href="/about">O Nas</a>
                        <div></div>
                    </li>
                    <li className="border-animation border-animation-horizontal"><a href="/contact">Kontakt</a>
                        <div></div>
                    </li>
                    <li className="border-animation border-animation-horizontal"><a href="/prices">Cennik</a>
                        <div></div>
                    </li>
                    <li className="border-animation border-animation-horizontal"><a href="/news">Aktualności</a>
                        <div></div>
                    </li>
                    <li className="border-animation border-animation-horizontal"><a href="/gallery">Galeria</a>
                        <div></div>
                    </li>
                    <li className="border-animation border-animation-horizontal"><a href="/cooperation">Współpraca</a>
                        <div></div>
                    </li>
                    <li className="border-animation border-animation-horizontal"><a href="/pit">Rozlicz z nami swój
                        PIT</a>
                        <div></div>
                    </li>
                </ul>
                <div className="navbar-social navbar-item">
                    <div className="navbar-social-container">
                        <a href="https://www.facebook.com/p/Biuro-Rachunkowe-Saldopl-Sp-z-o-o-Sp-K-100063704434164/">
                            <div className="navbar-social-item fb"></div>
                        </a>
                    </div>
                    <div className="navbar-social-container">
                        <a href="https://www.linkedin.com/company/biuro-rachunkowe-saldo-pl-sp-z-o-o-sp-k/posts/?feedView=all">
                            <div className="navbar-social-item li"></div>
                        </a>
                    </div>
                    </div>
                </div>
                )
                }
